import { ErrorHandler, Injectable, Injector, inject } from "@angular/core";
import { AppInsightsService } from "./services/app-insights.service";

@Injectable()
export class ErrorInterceptor implements ErrorHandler {
    private readonly injector = inject(Injector);

    handleError(error: any): void {
        // injecting AppInsightsService via injector to avoid infinite loop in case
        const appInsightsService = this.injector.get<AppInsightsService>(AppInsightsService);
        if (error?.error?.messageType === "ValidationMessage") {
            appInsightsService.trackTrace({
                message: `${error.name}: ${error.error.message}`
            });
        } else {
            appInsightsService.trackException(error);
        }
    }
}
